"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _cmsHubTitle = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/cms-hub-title.jpg"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 600;\n  font-size: 18px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-bottom: 24px;\n    grid-template-columns: 1fr 0;\n    text-align: center;\n    max-width: 80%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  max-width: 792px;\n  margin: 0 auto;\n  grid-column-gap: 36px;\n  align-items: center;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "Mon317ProductPageTitle__Container",
  componentId: "ykzk9h-0"
})(_templateObject(), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()));

var BoldTitle = _styledComponents.default.div.withConfig({
  displayName: "Mon317ProductPageTitle__BoldTitle",
  componentId: "ykzk9h-1"
})(_templateObject3());

var DesktopOnly = _styledComponents.default.div.withConfig({
  displayName: "Mon317ProductPageTitle__DesktopOnly",
  componentId: "ykzk9h-2"
})(_templateObject4(), _responsiveBreakpoints.default.tabletPortrait(_templateObject5()));

var Mon317ProductPageTitle = function Mon317ProductPageTitle(_ref) {
  var standardProductPageTitle = _ref.standardProductPageTitle,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["standardProductPageTitle"]);
  return _react.default.createElement(Container, rest, _react.default.createElement("div", {
    className: "flex-column"
  }, standardProductPageTitle, _react.default.createElement(BoldTitle, {
    className: "m-bottom-3"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: 'mon317.productPageTitle'
  })), _react.default.createElement(_FormattedMessage.default, {
    message: 'mon317.productPageSubtitle'
  })), _react.default.createElement(DesktopOnly, null, _react.default.createElement(_UIImage.default, {
    src: _cmsHubTitle.default
  })));
};

Mon317ProductPageTitle.propTypes = {
  standardProductPageTitle: _propTypes.default.node.isRequired
};
var _default = Mon317ProductPageTitle;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/Mon317ProductPageTitle.js
// module id = 874
// module chunks = 5 6